import { render } from "./OrgsHandlingPanel.vue?vue&type=template&id=484db3c7"
import script from "./OrgsHandlingPanel.vue?vue&type=script&lang=js"
export * from "./OrgsHandlingPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__